import { Typography } from "antd";
import { CSSProperties } from "react";

interface UnitAmountProps {
  color?: string;
  fontSize?: string | number;
  fontWeight?: string | number;
  style?: CSSProperties;
  /** Label rendered after the amount, e.g. "تومان", "پوند", "ماه". */
  unit?: string;
  amount?: number | string;
  [key: string]: any; // for ...props spread
}

/**
 * Renders a formatted numeric amount followed by a smaller unit label.
 * Currency-agnostic: the `unit` can be a currency name, "ماه", "روز", etc.
 * See {@link CurrencyAmount} for the currency-specific wrapper.
 */
export function UnitAmount({
  color = 'inherit',
  fontSize = 'inherit',
  fontWeight,
  style,
  unit = '',
  amount,
  ...props
}: UnitAmountProps) {
  const formattedAmount = isFinite(Number(amount || 0)) ? Number(amount || 0).toLocaleString("en-fa") : amount;
  return (
    <Typography.Text
      style={{
        display: 'inline-block',
        color,
        fontSize,
        ...style,
      }}
      {...props}
    >
      <code className="p-0 font-semibold whitespace-nowrap" style={{ fontSize, fontWeight: fontWeight ?? undefined }}>
        {formattedAmount}
      </code>
      {unit && (
        <>
          {' '}
          <span style={{ fontSize: '0.8em' }}>{unit}</span>
        </>
      )}
    </Typography.Text>
  );
}

export default UnitAmount;
